import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Culture, CultureService } from '@ndk/ng-i18n';
import { LocalStorageService } from '@ndk/ng-storage';
import { NDDTranslationConfig, NDDTranslationService } from '@ndk/ng-translation';

@Injectable()
export class CustomTranslationService extends NDDTranslationService {
    private isInitialized: boolean = false;

    constructor(
        @Inject(Window) windowRef: Window,
        private translationContig: NDDTranslationConfig,
        private localStorageService: LocalStorageService,
        cultureService: CultureService,
        http: HttpClient,
    ) {
        super(windowRef, translationContig, localStorageService, cultureService, http);
    }

    public get currentLang(): Culture {
        return this.localStorageService.getValue(this.translationContig.keys.currentLangKey);
    }

    public set currentLang(lang: Culture) {
        this.localStorageService.setValue(this.translationContig.keys.currentLangKey, lang);

        if (this.isInitialized) {
            this.onCurrentLangChanged.next(lang);
        } else {
            this.isInitialized = true;
            this.onFirstCurrentLangChanged.next(lang);
        }
    }
}
